import windowPopup from './windowPopup';
import stickybits from 'stickybits';
import './stickybits.css';

function cleanUpIframes() {
  // This removes all height/width from iframes
  const iframes = Array.from(document.querySelectorAll('iframe'));

  // Find & save the aspect ratio for all iframes
  iframes.forEach(iframe => {
    iframe.dataset.ratio = iframe.height / iframe.width;
    // Remove the hardcoded width & height attributes
    iframe.removeAttribute('width');
    iframe.removeAttribute('height');
  });

  // Resize the iframes when the window is resized
  const resize = () => {
    iframes.forEach(iframe => {
      // Get the parent container's width
      const width = iframe.parentElement.clientWidth;
      iframe.style.width = `${width}px`;
      iframe.style.height = `${width * iframe.dataset.ratio}px`;
    });
  };

  window.addEventListener('resize', resize);
  // Resize to fix all iframes on page load.
  resize();
}

function setupReadingProgress() {
  const progressBar = document.querySelector('progress');
  if (!progressBar) {
    return;
  }

  const getMax = () =>
    document.documentElement.scrollHeight -
    document.documentElement.clientHeight;
  const getValue = () => window.scrollY;

  // Set the Max attr for the first time
  progressBar.max = getMax();

  document.addEventListener('scroll', () => {
    // On scroll only Value attr needs to be calculated
    progressBar.value = getValue();
  });

  window.addEventListener('resize', () => {
    // On resize, both Max/Value attr needs to be calculated
    progressBar.max = getMax();
    progressBar.value = getValue();
  });
}

export default {
  init() {
    cleanUpIframes();

    stickybits('.child', {
      useStickyClasses: true,
      stickyBitStickyOffset: 300,
    });

    document.querySelectorAll('.js-social-share').forEach(link => {
      link.addEventListener('click', e => {
        e.preventDefault();
        windowPopup(link.getAttribute('href'), 500, 300);
      });
    });

    setupReadingProgress();
  },
  finalize() {},
};
